import { render, staticRenderFns } from "./CreateCenterPoint.vue?vue&type=template&id=197d4aec&scoped=true&"
import script from "./CreateCenterPoint.vue?vue&type=script&lang=ts&"
export * from "./CreateCenterPoint.vue?vue&type=script&lang=ts&"
import style0 from "./CreateCenterPoint.vue?vue&type=style&index=0&id=197d4aec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197d4aec",
  null
  
)

export default component.exports